import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import CurrencyInput from "@/components/atoms/CurrencyInput";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { convertCurrencyToNumber } from "@/helpers/currency-helpers";
import { PaymentDataTabMessages } from "@/messages/order-form-page/payment-data-tab.messages";

import { getOrderItemTotals } from "../../../ItemsTab/form-data";

type ValuesProps = {
  messages: PaymentDataTabMessages;
};

export default function Values({ messages }: ValuesProps) {
  const { values, errors, setFieldValue } = useFormikContext<OrderFormData>();
  const campaignDiscount =
    Number(values.discountCouponAmount) || getOrderItemTotals(values.items).couponDiscount;
  const displayedDiscount = campaignDiscount > 0 ? campaignDiscount : values.orderDiscount;

  const handlePaymentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = event.target.name;
    const numericValue = convertCurrencyToNumber(event.target.value);

    setFieldValue(fieldName, numericValue);
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between">
          <MDTypography variant="h5" fontWeight="bold">
            {messages.groupOrderValueTitle}
          </MDTypography>
        </MDBox>

        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <CurrencyInput
                name="orderFreight"
                label={messages.orderFreightLabel}
                value={values.orderFreight}
                onChange={handlePaymentChange}
                fullWidth
                error={!!errors.orderFreight}
                helperText={errors.orderFreight}
                InputLabelProps={{ shrink: true }}
                disabled={values.disabledButton}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <CurrencyInput
                name="orderDiscount"
                label={messages.orderDiscountLabel}
                value={displayedDiscount}
                onChange={handlePaymentChange}
                fullWidth
                error={!!errors.orderDiscount}
                helperText={errors.orderDiscount}
                InputLabelProps={{ shrink: true }}
                disabled={values.disabledButton || campaignDiscount > 0}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <CurrencyInput
                name="orderCharges"
                label={messages.orderChargesLabel}
                value={values.orderCharges}
                onChange={handlePaymentChange}
                fullWidth
                error={!!errors.orderCharges}
                helperText={errors.orderCharges}
                InputLabelProps={{ shrink: true }}
                disabled={values.disabledButton}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}
